import React, { FC } from 'react';
import { List } from '@mui/material';
import { PUBLIC_COMPANIES } from 'pages/Valuations/util/constants';
import { EQUITY_ALLOCATION_SCENARIO } from 'pages/ValuationsAllocation/common/constants/equityAllocation';
import { ApproachScenarioTypeOption, ApproachTypes } from 'pages/ValuationsAllocation/components';
import { StyledDialog } from './styles';
import { NewScenarioApproachDialogProps } from './types';

// updating here
const NewScenarioApproachDialog: FC<NewScenarioApproachDialogProps> = ({
  approachTypes,
  disableAddScenarioButton,
  handleApproachTypeClick,
  handleScenarioTypeClick,
  initialSelection,
  onDialogClose,
  openDialog,
  approaches,
}: NewScenarioApproachDialogProps) => {
  const hasGPC = approaches.some(approach => approach?.approach_type === PUBLIC_COMPANIES);

  return (
    <StyledDialog onClose={onDialogClose} open={openDialog}>
      <List>
        {/* Approaches */}
        {approachTypes.map(approach => (
          <ApproachScenarioTypeOption
            approach={approach}
            autoFocus={initialSelection === approach}
            onClick={handleApproachTypeClick}
            key={approach}
            {...(approach === 'Calibration' ? { isDisabled: !hasGPC } : {})}
          />
        ))}

        {/* Allocation Scenario */}
        <ApproachScenarioTypeOption
          approach={EQUITY_ALLOCATION_SCENARIO as ApproachTypes}
          autoFocus={initialSelection === EQUITY_ALLOCATION_SCENARIO}
          isDisabled={disableAddScenarioButton}
          key={EQUITY_ALLOCATION_SCENARIO}
          onClick={handleScenarioTypeClick}
        />
      </List>
    </StyledDialog>
  );
};

export default NewScenarioApproachDialog;
